import { render, staticRenderFns } from "./TextAssignment.vue?vue&type=template&id=cacb2700&"
import script from "./TextAssignment.vue?vue&type=script&lang=js&"
export * from "./TextAssignment.vue?vue&type=script&lang=js&"
import style0 from "./TextAssignment.vue?vue&type=style&index=0&id=cacb2700&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports